module.exports = __webpack_public_path__ + "img/SU_logo.3cdd3258.png";